'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = require('../constants');

/**
 * Determine the max range for the gas slider based on recommended gas price.
 *
 * @param {Number} recommendedGasPrice
 * @returns {Number}
 */
exports.default = function (recommendedGasPrice) {
  var recommendedMax = recommendedGasPrice * 2;
  return recommendedMax > _constants.DEFAULT_GAS_PRICE_MAX ? recommendedMax : _constants.DEFAULT_GAS_PRICE_MAX;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/utilities/calculateGasSliderMax.js
// module id = 461
// module chunks = 0